export default __webpack_public_path__ + "static/media/graph-selected.61f35d1f.svg";